import { urlApiUser } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IAccountPermission, IAccountProfile } from '~/utils/interface/auth';
import { IBaseResponse } from '~/utils/interface/base';

// GET /users/profile also serves the mobile apps, so it returns the account
// profile nested under `profile` alongside `permission` (used to gate App Setup
// tabs), `staffFeatures` (the admin pages a staff role grants) and unrelated sibling data (missed call/voicemail counts...) the web ignores.
const userApi = {
  getProfile() {
    return axiosClient.get<IBaseResponse<{ profile: IAccountProfile; permission?: IAccountPermission; staffFeatures?: string[] }>>(urlApiUser.profile);
  },
  // multipart because the route also takes the avatar image (field avatarImage)
  updateProfile(body: FormData) {
    return axiosClient.put<IBaseResponse<unknown>>(urlApiUser.profile, body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  changePassword(body: { currentPassword: string; newPassword: string }) {
    return axiosClient.put<IBaseResponse<unknown>>(urlApiUser.changePassword, body);
  },
};

export default userApi;
